import styles from './../styles.module.scss';
import skeleton from './styles.module.scss';
export default function SkeletonRankedBadge() {
  return (
    <div className={`${styles.badge} ${skeleton.container}`}>
      <div className={skeleton.banner} />
      <div>
        <p className={styles['badge__ranked-vip']}>
          <div className={skeleton.text} />
        </p>
      </div>
    </div>
  );
}
